"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validations_1 = require("../../utils/validations");
function updateModuleSessionMarkOnCondition(existingMark, { mark: sessionMark }, shouldUpdate) {
    if (!(0, validations_1.isNumber)(existingMark) || shouldUpdate) {
        return sessionMark;
    }
    return existingMark;
}
exports.default = updateModuleSessionMarkOnCondition;
